import React, { useState } from 'react';
import PortalIcon from './PortalIcon';

// Typing the exact name back is a deliberate speed bump for an
// irreversible action — a plain "Er du sikker?" confirm is too easy to
// click through without reading, especially in a table row where the
// delete button sits right next to view/edit.
export default function ConfirmDeleteModal({ title, itemName, warning, confirmLabel = 'Slet permanent', onConfirm, onCancel }) {
  const [typed, setTyped] = useState('');
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState('');
  const matches = typed.trim().length > 0 && typed.trim() === itemName;

  async function handleConfirm() {
    if (!matches || deleting) return;
    setDeleting(true);
    setError('');
    try {
      await onConfirm();
    } catch (err) {
      setError(err.message);
      setDeleting(false);
    }
  }

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-panel modal-panel--danger" onClick={(e) => e.stopPropagation()}>
        <div className="modal-panel__head">
          <div className="modal-panel__title">
            <span className="modal-panel__ico modal-panel__ico--danger"><PortalIcon name="trash" size={21} /></span>
            <h2>{title}</h2>
          </div>
          <button className="modal-panel__close" onClick={onCancel} aria-label="Luk">×</button>
        </div>
        <div className="modal-panel__body">
          <p className="modal-danger-warning">
            <strong>{warning || 'Denne handling er permanent og kan ikke fortrydes.'}</strong>
          </p>
          <div className="form-field">
            <label>Skriv "{itemName}" for at bekræfte</label>
            <input value={typed} onChange={(e) => setTyped(e.target.value)} autoFocus disabled={deleting} />
          </div>
          {error && <p className="modal-msg modal-msg--error">{error}</p>}
          <div className="modal-danger-actions">
            <button type="button" className="btn-secondary" onClick={onCancel} disabled={deleting}>Annullér</button>
            <button type="button" className="btn-delete" onClick={handleConfirm} disabled={!matches || deleting}>
              {deleting ? 'Sletter…' : confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
